import { createCoreMethod } from '../../utils/createCoreMethod';
import { ApiConfig, getApiBasedConfig } from '../../utils/getApiBasedConfig';

export const getConfig = createCoreMethod('getConfig', async () => {
  return new Promise<ApiConfig>((resolve) => {
    const config = getApiBasedConfig();

    resolve(config);
  });
});
